import script from "./ProvaFinalizada.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvaFinalizada.vue?vue&type=script&setup=true&lang=js"

import "./ProvaFinalizada.vue?vue&type=style&index=0&id=b54107a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b54107a6"]])

export default __exports__